module.exports = __webpack_public_path__ + "static/media/slider_1_collab_user_en.1f065027.svg";